import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { EnrollStudentToBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const enrollStudentToBatch = createApiThunk<void, EnrollStudentToBatchBody>(
  "batches/enrollStudentToBatch",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.enrollStudent(body);
  },
);

export const resetEnrollStudentToBatch = createAction("batches/resetEnrollStudentToBatch");
